const EcUnits = [
	{ label: "ppm", value: 0.55},
	{ label: "dS/cm", value: 100000 },
	{ label: "mS/cm", value: 1000 },
	{ label: "uS/cm", value: 1 },
];

export {
	EcUnits
}